import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    classes: Array
  }

  connect() {
    try {
      if (!this.classesValue || this.classesValue.length === 0) return

      const tables = this.element.querySelectorAll('table')
      const tableClasses = this.classesValue.filter(cls => cls.startsWith('table'))

      if (tableClasses.length === 0) return

      tables.forEach(table => {
        table.classList.add(...tableClasses)
      })
    } catch (error) {
      console.log("classesValue is missing")
      console.log(error)
    }
  }
}
